module.exports = __webpack_public_path__ + "static/media/FOND.74758fe1.png";